export default __webpack_public_path__ + "static/media/eng-flag.1371755b.svg";